<template>
  <a-dialog v-model="show">
    <div
      slot="header"
      v-t="'Config.UserProfile.ProfilePreferences.DeleteImageDialogTitle'"
    />
    <div
      slot="body"
      v-t="'Config.UserProfile.ProfilePreferences.DeleteImageDialogText'"
    />
    <div slot="footer">
      <button
        v-t="'Config.UserProfile.ProfilePreferences.AbortLeave'"
        type="button"
        class="btn btn-pf-secondary mr-2"
        @click="cancelDialog()"
      />
      <button
        v-t="'Config.UserProfile.ProfilePreferences.AcceptLeave'"
        type="button"
        class="btn btn-pf-primary"
        @click="$emit('reset-user-image')"
      />
    </div>
  </a-dialog>
</template>

<script>
import Dialog from "+/components/dialog/Dialog";

export default {
  components: {
    "a-dialog": Dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.cancelDialog();
      }
    }
  },
  methods: {
    cancelDialog() {
      this.$emit("input", false);
    }
  }
};
</script>
